import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { base } from "../../constants/apis";
import CookieService from "../../context/cookies";
import {
  CarrierCodeRes,
  ContainerTrackingRes,
  LogisticCarrierCode,
} from "../../types/ContainerTracking";

export const containerTrackingApi = createApi({
  reducerPath: "containerTrackingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${base}/apis/gocomet`,
    prepareHeaders: (headers) => {
      const token = CookieService.getCookie("jwtToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["containerTrackingApi"],
  endpoints: (builder) => ({
    getContainerStatus: builder.query<ContainerTrackingRes, { row_id: string }>(
      {
        query: (payload) => ({
          url: "/get_tracking.php",
          method: "POST",
          body: payload,
        }),
        providesTags: ["containerTrackingApi"],
      }
    ),

    addContainerTracking: builder.mutation({
      query: (payload) => ({
        url: "/add_tracking.php",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["containerTrackingApi"],
    }),

    getCarrierCodeList: builder.query<
      LogisticCarrierCode[],
      { search_query: string }
    >({
      query: (payload) => ({
        url: "/carrier_code_list.php",
        method: "POST",
        body: payload,
      }),

      transformResponse: (res: CarrierCodeRes) => res.data,
    }),
  }),
});

export const {
  useGetContainerStatusQuery,
  useAddContainerTrackingMutation,
  useLazyGetCarrierCodeListQuery,
} = containerTrackingApi;
